import { c as _c } from "react/compiler-runtime";
import { Badge, Button, Card, Heading, HStack, SimpleGrid, Text, VStack } from '@chakra-ui/react';
import { BaseballCard } from '@src/components/sco/Advisors/cards/BaseballCard';
import { filterEngagements, useAdvisorBoard } from '@src/components/sco/Advisors/hooks/useAdvisorBoard';
import { BoardSeatsLayout } from '@src/components/sco/Advisors/layout/BoardSeatsLayout';
import { useAdvisorsPaths } from '@src/components/sco/Advisors/paths';
import { AdvisorsQueryState } from '@src/components/sco/Advisors/shared/AdvisorsQueryState';
import { engagementToBaseballCard } from '@src/components/sco/Advisors/utils/mapEngagements';
import { seatsNavItems } from '@src/components/sco/Advisors/utils/seatsNav';
export const MyAdvisorsSection = () => {
  const $ = _c(45);
  const paths = useAdvisorsPaths();
  let t0;
  if ($[0] !== paths) {
    t0 = seatsNavItems(paths).find(_temp);
    $[0] = paths;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const navItem = t0;
  const query = useAdvisorBoard();
  let T0;
  let T1;
  let T2;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[2] !== navItem?.description || $[3] !== navItem?.title || $[4] !== paths.base || $[5] !== query.data?.advisorBoard || $[6] !== query.error || $[7] !== query.isInitialLoading) {
    const board = filterEngagements(query.data?.advisorBoard);
    let t10;
    if ($[20] !== paths.base) {
      t10 = engagement => engagementToBaseballCard(engagement, {
        base: paths.base
      });
      $[20] = paths.base;
      $[21] = t10;
    } else {
      t10 = $[21];
    }
    const cards = board.map(t10);
    T2 = BoardSeatsLayout;
    t7 = "board";
    t8 = navItem?.description;
    t9 = navItem?.title ?? "On your board";
    T1 = AdvisorsQueryState;
    t4 = query.error;
    t5 = query.isInitialLoading;
    let t11;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <Text color="colorPalette.fg/60" textStyle="labelXs">On your board</Text>;
      $[22] = t11;
    } else {
      t11 = $[22];
    }
    t6 = <HStack align="center" justify="space-between">{t11}<Badge colorPalette="green" variant="subtle">{board.length} {board.length === 1 ? "advisor" : "advisors"}</Badge></HStack>;
    T0 = SimpleGrid;
    if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = {
        base: 1,
        md: 2,
        xl: 3
      };
      $[23] = t1;
    } else {
      t1 = $[23];
    }
    t2 = 5;
    t3 = cards.map(_temp2);
    $[2] = navItem?.description;
    $[3] = navItem?.title;
    $[4] = paths.base;
    $[5] = query.data?.advisorBoard;
    $[6] = query.error;
    $[7] = query.isInitialLoading;
    $[8] = T0;
    $[9] = T1;
    $[10] = T2;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    T0 = $[8];
    T1 = $[9];
    T2 = $[10];
    t1 = $[11];
    t2 = $[12];
    t3 = $[13];
    t4 = $[14];
    t5 = $[15];
    t6 = $[16];
    t7 = $[17];
    t8 = $[18];
    t9 = $[19];
  }
  let t10;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Card.Body><HStack align="center" gap={4} justify="space-between" wrap="wrap"><VStack align="stretch" gap={1}><Heading size="md">Need more help?</Heading><Text color="colorPalette.fg/70" fontSize="sm">Open a board seat and bring the right advisors onto your board.</Text></VStack><Button pointerEvents="none" variant="cta">Add board seats</Button></HStack></Card.Body>;
    $[24] = t10;
  } else {
    t10 = $[24];
  }
  let t11;
  if ($[25] !== paths.seatNew) {
    t11 = <Card.Root asChild={true} variant="outline"><a href={paths.seatNew}>{t10}</a></Card.Root>;
    $[25] = paths.seatNew;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== T0 || $[28] !== t1 || $[29] !== t11 || $[30] !== t2 || $[31] !== t3) {
    t12 = <T0 columns={t1} gap={t2}>{t3}{t11}</T0>;
    $[27] = T0;
    $[28] = t1;
    $[29] = t11;
    $[30] = t2;
    $[31] = t3;
    $[32] = t12;
  } else {
    t12 = $[32];
  }
  let t13;
  if ($[33] !== T1 || $[34] !== t12 || $[35] !== t4 || $[36] !== t5 || $[37] !== t6) {
    t13 = <T1 error={t4} loading={t5}>{t6}{t12}</T1>;
    $[33] = T1;
    $[34] = t12;
    $[35] = t4;
    $[36] = t5;
    $[37] = t6;
    $[38] = t13;
  } else {
    t13 = $[38];
  }
  let t14;
  if ($[39] !== T2 || $[40] !== t13 || $[41] !== t7 || $[42] !== t8 || $[43] !== t9) {
    t14 = <T2 activeKey={t7} description={t8} title={t9}>{t13}</T2>;
    $[39] = T2;
    $[40] = t13;
    $[41] = t7;
    $[42] = t8;
    $[43] = t9;
    $[44] = t14;
  } else {
    t14 = $[44];
  }
  return t14;
};
function _temp(item) {
  return item.key === "board";
}
function _temp2(card) {
  return <BaseballCard key={card.name} card={card} />;
}